import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Col, Row } from 'reactstrap'
import Section from '../../../common/Section'
import Logo from '../../../navbar/Logo'
import bg1 from '../../../../assets/img/generic/condominium.jpg'
import ProviderRegisterWizard from './ProviderRegisterWizard'

const ProviderRegisterLayout = () => {
  useEffect(() => {
    document.title = 'Homelan | Registro de proveedores'
  }, [])

  return (
    <Section className="py-0" image={bg1} position="center bottom" overlay>
      <Row className="flex-center min-vh-100 py-6">
        <Col sm={11} lg={9} xl={8} className="col-xxl-6">
          <Logo bordered />
          <ProviderRegisterWizard />
          <p className="text-center text-white fs--1 mt-3 mb-0">
            ¿Ya tienes una cuenta?{' '}
            <Link to="/authentication/login" className="text-white font-weight-semi-bold">
              Inicia sesión
            </Link>
          </p>
        </Col>
      </Row>
    </Section>
  )
}

export default ProviderRegisterLayout
